import React, { useState, useEffect } from "react";
import TaskInput from "./TaskInput";
import TaskLists from "./TaskLists";
import style from "./Task.module.css";
import TaskAddButton from "./TaskAddButton";

function Task() {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [taskIdCount, setTaskIdCount] = useState(1);
  const [tasks, setTasks] = useState([
    {
      task: "",
      note: "",
      taskId: 0,
    },
  ]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editTask, setEditTask] = useState({
    editTasdId: 0,
    editaTask: "",
    editNote: "",
  });

  const editTaskHandler = (taskId) => {
    if (taskId === 0) {
      return;
    } else {
      console.log(tasks[0].task);
    }
    setEditTask({
      editTaskId: taskId,
      editaTask: tasks[taskId].task,
      editNote: tasks[taskId].note,
    });
  };

  const ModalHandler = () => {
    setIsModalOpen(!isModalOpen);
  };

  const taskDropdownHandler = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const setTasksHandler = (newTask, newNote, newTaskId) => {
    if (!newTaskId) {
      newTaskId = taskIdCount;
      setTaskIdCount(taskIdCount + 1);
    } else {
      const newState = [...tasks];
      newState[newTaskId] = {
        task: newTask,
        note: newNote,
        taskId: newTaskId,
      };
      setTasks(newState);
      setEditTask({
        editTasdId: 0,
        editaTask: "",
        editNote: "",
      });
      return;
    }

    setTasks([
      ...tasks,
      {
        taskId: newTaskId,
        task: newTask,
        note: newNote,
      },
    ]);
    setEditTask({
      editTasdId: 0,
      editaTask: "",
      editNote: "",
    });
  };

  return (
    <div className={style.container}>
      <div className={style.taskText1}>Time to Work!</div>
      <div className={style.taskText2}>Tasks</div>
      <div className={style.dropdown} onClick={taskDropdownHandler}>
        <span>...</span>
        <div
          className={`${style.dropdownContent} ${
            isDropdownOpen ? style.active : ``
          }`}
        >
          <li className={style.li} onClick={() => setTasks({})}>
            Clear Finished Tasks
          </li>
        </div>
      </div>
      <div className={style.divider} />

      <TaskAddButton
        editTask={editTask}
        isModalOpen={isModalOpen}
        ModalHandler={ModalHandler}
        setTasksHandler={setTasksHandler}
      />

      <ul className={style.ul}>
        {/* <TaskInput /> */}
        {tasks.slice(1).map((task) => (
          <TaskLists
            editTaskHandler={editTaskHandler}
            ModalHandler={ModalHandler}
            task={task}
          />
        ))}
      </ul>
    </div>
  );
}

export default Task;
